import dayjs from 'dayjs';

export const INVOICE_MOCK_OPTIONS = [
  {
    label: 'John Smith',
    value: '8b173225-35f7-4456-822c-16bc69a4e9d2',
  },
];

export const INVOICE_MOCK_DATA = {
  leadId: '8b173225-35f7-4456-822c-16bc69a4e9d2',
  dueAt: dayjs().add(7, 'days').toDate(),
  terms: 'ONE_TIME',
  items: [
    {
      type: 'AMOUNT',
      name: 'Web Development',
      price: 10000,
      quantity: 1,
      description: 'Web Development service billed at a set amount',
      _id: 'b11b94ce-e189-4f5f-ae22-d5a002f72da6',
    },
  ],
};

export const INVOICE_MOCK_PRODUCTS = [
  {
    itemLabel: 'Web Development',
    value: 'b11b94ce-e189-4f5f-ae22-d5a002f72da6',
    description: 'Web Development service billed at a set amount',
  },
];

export const INVOICE_MOCK_LEAD = {
  fullName: 'John Smith',
  companyId: {
    name: 'Leapify',
    city: 'Beverly Hills',
    state: 'CA',
    postalCode: '90210',
    _id: '3062d135-1668-4adf-98dc-5084ce1858f3',
    type: '',
    industry: '',
  },
};
